import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
	Card,
	CardHeader,
	CardContent,
	Typography,
	Input,
	CardActions,
	Button,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ImageGridList from './imageGridList';
import { useSnackbar } from 'notistack';

const useStyles = makeStyles(theme => ({
	warning: {
		backgroundColor: theme.palette.warning.main,
		color: '#FFF',
	},
}));

const SelectImageCard = ({
	title,
	subTitle,
	multiple,
	images = [],
	name,
	handleSelect,
	handleClear,
	limit = 6,
	onDelete = () => {},
	onReorder = () => {},
}) => {
	const classes = useStyles();

	const [inputKey, setInputKey] = useState(Date.now());

	const { enqueueSnackbar } = useSnackbar();

	const onClear = () => {
		handleClear();
		setInputKey(Date.now());
	};

	const renderImageList = () => {
		if (Array.isArray(images)) {
			const imageArray = images.map(item => {
				if (item && item.url) return item.url;
				if (item && item.blob) return item.blob;
				return null;
			});
			return (
				<ImageGridList
					images={imageArray}
					onDelete={onDelete}
					onReorder={onReorder}
				/>
			);
		} else {
			var singleImageToPass = null;
			if (images.url) singleImageToPass = images.url;
			if (images.blob) singleImageToPass = images.blob;

			return <ImageGridList images={[singleImageToPass]} onDelete={onDelete} />;
		}
	};

	const onImageChange = async event => {
		const files = Array.from(event.target.files);
		const types = ['image/png', 'image/jpeg'];
		if (
			types?.every(type => files[0].type !== type) ||
			files.length == 0 ||
			files.length > limit
		) {
			return enqueueSnackbar(`invalid image type, or size is to large `, {
				variant: 'error',
			});
		}

		try {
			const images = files.map(file => {
				return { blob: URL.createObjectURL(file), file: file };
			});

			handleSelect(images, event.target?.name);
		} catch (error) {
			console.log(error);
		}
	};

	return (
		<Card>
			<CardHeader title={title} />
			<CardContent>
				<Typography variant='h6'>{subTitle}</Typography>
				<Input
					type='file'
					name={name}
					onChange={onImageChange}
					inputProps={{ multiple: multiple }}
					key={inputKey}
				/>
				{renderImageList()}
			</CardContent>
		</Card>
	);
};

SelectImageCard.propTypes = {
	title: PropTypes.string.isRequired,
	subTitle: PropTypes.string.isRequired,
	images: PropTypes.array.isRequired,
	name: PropTypes.string,
};

export default SelectImageCard;
